import PropTypes from 'prop-types';

const displayName = 'FormProduct';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
